import { FC, ComponentProps } from "react";
import * as _ from "lodash";
import Markdown from "react-markdown";

import { Col, List, PlusCircleOutlined, Popover, Row, Space, Tag } from "@ctra/components";
import { Enterprise, useTranslation } from "@ctra/i18n";
import { isProduction } from "@ctra/utils";

import { useDataDictionary } from "@base";

import styles from "./ListItem.module.less";
import { MetricEntity } from "@ctra/api";

const {
  analytics: {
    config: {
      metric: { displayName },
      projections
    }
  }
} = Enterprise;

interface ListItemProps extends ComponentProps<typeof List.Item> {
  id: MetricEntity["id"];
  name: string;
}

/**
 * List item for the category list displayed on config search page
 * @param {string} id
 * @param {string} name
 * @param {((event: React.MouseEvent<HTMLDivElement>) => void) | undefined} onClick
 * @returns {JSX.Element}
 * @constructor
 */
export const ListItem: FC<ListItemProps> = ({ id, name, onClick }) => {
  const { t } = useTranslation();

  const {
    groups: { projectionMetrics }
  } = useDataDictionary();

  return (
    <List.Item key={id} onClick={onClick}>
      <Row justify="space-between" align="middle" className={styles.Item}>
        <Col>
          <Space wrap={false} size={"middle"}>
            <Col>
              {isProduction() ? (
                <PlusCircleOutlined className={styles.Icon} />
              ) : (
                <Popover content={<Markdown>{id}</Markdown>} trigger="hover">
                  <PlusCircleOutlined className={styles.Icon} />
                </Popover>
              )}
            </Col>
            <Col>
              {t<string>(displayName(name), {
                makeDefaultValue: true
              })}
            </Col>
          </Space>
        </Col>
        <Col>{_.includes(projectionMetrics, id) && <Tag className={styles.Tag}>{t(projections)}</Tag>}</Col>
      </Row>
    </List.Item>
  );
};
